let result = {
    communicationUrl: "https://localhost:8123/test.html"
}
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    result = {
        communicationUrl: "https://localhost:8123/test.html"
    }
}

export default result